import * as React from "react";
import * as icons from "../../icons";
import join from "../../utils/join-path";
import Sidebar from "../sidebar/Sidebar";
import SidebarLink from "../sidebar/SidebarLink";
import SidebarDivider from "../sidebar/SidebarDivider";

const FranchiseSidebar = ({ match }) => (
  <Sidebar>
    <SidebarLink
      to={join(match.url, "/jobs")}
      icon={icons.FOLDER}
      text="Jobs"
    />
    <SidebarLink
      to={join(match.url, "/reports")}
      icon={icons.SHOW_CHART}
      text="Reports"
    />
    <SidebarDivider />
    <SidebarLink to={`${match.url}/staff`} icon={icons.PEOPLE} text="Staff" />
  </Sidebar>
);

export default FranchiseSidebar;



// WEBPACK FOOTER //
// ./src/components/franchise/Sidebar.js